// ENTITY fr.gestionpial.pial.dto.PreferenceAeshDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Ecole } from './Ecole';
import { PreferenceAesh } from './PreferenceAesh';

export class PreferenceAeshDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.PreferenceAeshDTO';

  aeshPrenom: string | null = '';
  aeshNom: string | null = '';
  pialNom: string | null = '';
  ecoles: Ecole[] | null = [];
  preferences: PreferenceAesh[] | null = [];

  constructor(init?:Partial<PreferenceAeshDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.PreferenceAeshDTO'] = PreferenceAeshDTO;

fields['fr.gestionpial.pial.dto.PreferenceAeshDTO']  = {
    aeshPrenom: 'java.lang.String',
    aeshNom: 'java.lang.String',
    pialNom: 'java.lang.String',
    ecoles: 'java.util.List<fr.gestionpial.pial.entities.Ecole>',
    preferences: 'java.util.List<fr.gestionpial.pial.entities.PreferenceAesh>'
};
